import React, { useState, useContext, useEffect, useRef } from "react";
import {
  LoaderWrapper,
  ManageCensusLayout,
  WarningModal,
} from "../../../components";
import { Form, Formik } from "formik";
import { Button } from "react-bootstrap";
import {
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getPathWithParam,
  MANAGE_CENSUS_ROUTES,
  MANAGE_TRANSACTION_ROUTES,
  ROUTES,
} from "../../../utils";
import RollOverPlanCard from "../../../components/RollOverPlanCard";
import {
  manageCensusStore,
  setRollOverRequestPageData,
  setManageCensusLocalCache,
} from "../../../contexts";
import { useRouterParams, useDeepEffect } from "../../../abstracts";
import RollOverPlanDetailsContainer from "../RollOverPlanDetailsContainer";
import {
  censusFormFields,
  manageCensusFormNames,
} from "../../../utils/constants/employee";
import {
  getPlanDetailsByEmployeeId,
  getSourceAndInvestmentAgainstSourceByPlanId,
  saveRolloverInRequest,
  getRolloverInRequestDetailsById,
  saveRollOverDocuments,
} from "../../../services";
import "../../../styles/containers/RollOverDetailsContainer.scss";

const paymentOptions = [
  {
    label: "Cheque",
    value: 1,
  },
  {
    label: "EFT",
    value: 2,
  },
];

const plantypeOptions = [
  {
    label: "401(K)",
    value: 1,
  },
  {
    label: "403(B)",
    value: 2,
  },
  {
    label: "457(B)",
    value: 3,
  },
];

const RollOverRequestContainer = (props) => {
  const [selectedPlan, setSelectedPlan] = useState(0);
  const { dispatch, state } = useContext(manageCensusStore);
  const { flow, censusId, requestId, fromPage } = useRouterParams(); //fromPage -1 - from transactions page, 2 - from employee transaction page
  const formName = manageCensusFormNames.ROLLOVER_REQUEST;
  const fields = censusFormFields[formName];
  const { history } = props;
  const [planDetails, setPlanDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(0);
  const runValidations = useRef(false);
  const [selectPlanError, setSelectPlanError] = useState("");
  const [sourceValidations, setSourceValidations] = useState({});
  const [removeRadioButton, setRemoveRadioButton] = useState(false);
  const status = useRef(1);
  const [hasRothRollOverSource, setRothHasRollOverSource] = useState(false);
  const [
    sourceLevelContributionTableError,
    setSourceLevelContributionTableError,
  ] = useState("");
  const buttons =
    fromPage == 2
      ? [
          {
            label: "Save Draft",
            variant: "secondary",
            type: "submit",
            onClick: () => {
              runValidations.current = false;
            },
          },
          {
            label: "Cancel",
            variant: "secondary",
            type: "button",
            onClick: () => {
              history.push(
                getAdvancedPathWithParam({
                  path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                  pathParam: [FLOW_TYPES.EDIT, censusId],
                })
              );
            },
          },

          {
            label: "Next",
            variant: "primary",
            type: "submit",
            onClick: () => {
              runValidations.current = true;
            },
          },
        ]
      : // :
        // fromPage == 4 ? [
        //   {
        //     label: "Save Draft",
        //     variant: "secondary",
        //     type: "submit",
        //     // onClick: () => {
        //     //   runValidations.current = true;
        //     // },
        //   },
        //   {
        //     label: "Cancell",
        //     variant: "secondary",
        //     type: "button",
        //     onClick: () => {
        //       history.push(
        //         getAdvancedPathWithParam({
        //           path: MANAGE_TRANSACTION_ROUTES.DRAFT,
        //           // pathParam: [censusId, requestId],
        //         })
        //       );
        //     },
        //   },

        //   {
        //     label: "Nextty",
        //     variant: "primary",
        //     onClick: () => {
        //       history.push(
        //         getAdvancedPathWithParam({
        //           path: MANAGE_CENSUS_ROUTES.ROLLOVER_SUMMARY,
        //           pathParam: [flow,censusId, requestId,fromPage],
        //         })
        //       );
        //     },

        //   },
        // ] :
        [
          {
            label: "Cancel",
            variant: "secondary",
            type: "button",
            onClick: () => {
              history.push(
                getAdvancedPathWithParam({
                  path:
                    status.current === 1
                      ? MANAGE_TRANSACTION_ROUTES.DRAFT
                      : MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERINAPPROVAL,
                  pathParam: status.current === 1 ? [] : [censusId, requestId],
                })
              );
            },
          },

          {
            label: "Next",
            variant: "primary",
            type: "submit",
            onClick: () => {
              runValidations.current = true;
            },
          },
        ];

  useEffect(() => {
    setIsLoading(true);
    getPlanDetailsByEmployeeId(censusId)
      .then((response) => {
        if (response.isSuccessfull) {
          setPlanDetails(response.plan);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
    if (!requestId || requestId == 0) return;
    setIsLoading(true);
    getRolloverInRequestDetailsById(parseInt(requestId, 10))
      .then((response) => {
        setIsLoading(false);
        setFormValues({
          ...response,
          ...response.previousEmploymentDetails,
          ...response.rollOverTransactionInfo,
          checkLeaf: response.documentDetails?.filter((x) => x.type == 1),
          spousalConsentForm: response.documentDetails?.filter(
            (x) => x.type == 2
          ),
        });

        setSelectedPlan(response.planDetails.id);
        status.current = response.status;
        //setPageData(response)
      })
      .catch((ex) => {
        setIsLoading(false);
      });
  }, []);

  //Used to bind a single selected plan when request is saved
  useDeepEffect(
    () => {
      if (
        !requestId ||
        requestId == 0 ||
        formValues === 0 ||
        planDetails?.length === 0
      )
        return;
      setPlanDetails(
        planDetails.filter((x) => x.planId === formValues.planDetails.id)
      );
      setRemoveRadioButton(true);
    },
    [planDetails, formValues],
    true
  );
  const prepData = (values) => {
    return {
      runValidations: runValidations.current,
      rollOverRequestInformation: {
        ...values,
        planDetails: {},
        employeeId: parseInt(censusId, 10),
        planId: values.planId,
        planDetails: {},
        previousEmploymentDetails: {
          ...values,
        },
        rollOverTransactionInfo: {
          ...values,
        },
      },
    };
  };
  const validations = (values, setFieldError) => {
    let hasValidations = false;
    setSourceValidations({});
    if (hasRothRollOverSource && !values[fields.rothFirstContributionDate]) {
      setFieldError(fields.rothFirstContributionDate, "RI013 : Required");
      hasValidations = true;
    }
    values.sourceLevelInvestments.map((sourceLevelInvestment, ind) => {
      let sum = 0,
        isnull = false;
      sourceLevelInvestment.forEach((curr) => {
        if (
          [null, NaN, "", "", undefined].includes(curr.investmentPercentage)
        ) {
          sum += 0;
        } else {
          sum += curr.investmentPercentage;
          isnull = true;
        }
      });
      if (!isnull) {
        setSourceValidations((prev) => ({
          ...prev,
          [ind]: "RI016 : Please enter the % value",
        }));
        hasValidations = true;
      } else if (sum != 100) {
        setSourceValidations((prev) => ({
          ...prev,
          [ind]:
            "RI017 : The total value of investment election should not exceed or subceed 100%",
        }));
        hasValidations = true;
      }
    });
    return hasValidations;
  };
  const uploadFile = (values, rollOverId) => {
    var formData = new FormData();
    const dataInCheckLeafAndNotInEditState =
      values[fields.checkLeaf] && values[fields.checkLeaf]?.[0]?.lastModified;
    const dataInSpousalConsentAndNotInEditState =
      values[fields.spousalConsentForm] &&
      values[fields.spousalConsentForm]?.[0]?.lastModified;
    const isCheckLeafDeleted =
      values[fields.checkLeaf] && values[fields.checkLeaf][0]?.deleted === true;
    const isSpousalConsentDeleted =
      values[fields.spousalConsentForm] &&
      values[fields.spousalConsentForm][0]?.deleted === true;
    if (dataInCheckLeafAndNotInEditState)
      formData.append(1, values[fields.checkLeaf][0]);
    if (dataInSpousalConsentAndNotInEditState)
      formData.append(2, values[fields.spousalConsentForm][0]);
    if (isCheckLeafDeleted) formData.append(1, null);
    if (isSpousalConsentDeleted) formData.append(2, null);
    formData.append("rollOverId", rollOverId);
    if (
      dataInCheckLeafAndNotInEditState ||
      dataInSpousalConsentAndNotInEditState ||
      isCheckLeafDeleted ||
      isSpousalConsentDeleted
    )
      saveRollOverDocuments(formData)
        .then((response) => {
          if (response.isSuccessfull) {
            setIsLoading(false);
            reDirectToNextPage(values, rollOverId);
          }
        })
        .catch((ex) => {
          setIsLoading(false);
        });
    else {
      setIsLoading(false);
      reDirectToNextPage(values, rollOverId);
    }

    return true;
  };
  const reDirectToNextPage = (values, rollOverId) => {
    history.push(
      getAdvancedPathWithParam({
        path: runValidations.current //for next button
          ? status.current === 2
            ? MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERINAPPROVAL
            : MANAGE_CENSUS_ROUTES.ROLLOVER_SUMMARY
          : fromPage == 1
          ? MANAGE_TRANSACTION_ROUTES.DRAFT
          : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS, // for Save as draft
        pathParam: runValidations.current
          ? status.current === 2
            ? [censusId, requestId]
            : [flow, censusId, rollOverId, fromPage]
          : fromPage == 1
          ? []
          : [FLOW_TYPES.EDIT, censusId],

        // : [FLOW_TYPES.EDIT, censusId],
      })
    );
  };
  const onFormSubmit = (values, { setFieldError }) => {
    setSourceLevelContributionTableError("");
    setSelectPlanError("");
    if (!selectedPlan) {
      setSelectPlanError("RI024 : Required");
      return;
    } //dont call Api when plan is not selected
    setIsLoading(true);
    // if (values.id) uploadFile(values); //if id is present two apis are called simultaneously
    saveRolloverInRequest(prepData(values))
      .then((result) => {
        if (result.isSuccessfull) {
          if (runValidations.current && validations(values, setFieldError)) {
            setIsLoading(false);
            return;
          }
          dispatch(
            setManageCensusLocalCache({
              model: "rollOverRequestData",
              data: result.rollOverRequestInformation,
            })
          );
          uploadFile(values, result.rollOverRequestInformation.id);
        } else {
          setIsLoading(false);
          for (var i = 0; i < result?.errorMessages?.length; i++) {
            var _ = result.errorMessages[i];
            if (_.controlName === "sourceLevelContributionTableError")
              setSourceLevelContributionTableError(
                `${_.errorCode} : ${_.message}`
              );
            else setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
          validations(values, setFieldError);
          return;
        }
      })
      .catch((ex) => {
        setIsLoading(false);
      });
  };
  return (
    <>
      <Formik
        initialValues={{
          planDetails: planDetails,
          ...formValues,
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            resetForm,
            fieldValue,
            ...rest
          } = formProps;
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          return (
            <Form onSubmit={handleSubmit}>
              <ManageCensusLayout
                buttons={buttons}
                layoutHeader="New Rollover Request"
              >
                <div style={{ overflow: "auto", width: "60vw" }}>
                  <LoaderWrapper isLoading={isLoading} className="">
                    <div className="w-100">
                      <p
                        style={{
                          fontSize: "18px",
                          fontWeight: "500",
                          color: "#000000",
                        }}
                      >
                        Select Plan
                      </p>
                      <p className="rollOverErrorStyle">{selectPlanError}</p>
                      <RollOverPlanCard
                        plans={planDetails}
                        selectedPlan={selectedPlan}
                        setSelectedPlan={setSelectedPlan}
                        values={values}
                        setValues={setValues}
                        fields={fields}
                        setFieldValue={setFieldValue}
                        removeRadioButton={removeRadioButton}
                      />
                      {selectedPlan !== 0 && (
                        <RollOverPlanDetailsContainer
                          plans={planDetails}
                          paymentOptions={paymentOptions}
                          plantypeOptions={plantypeOptions}
                          formValues={formValues}
                          requestId={requestId}
                          selectedPlan={selectedPlan}
                          setSelectedPlan={setSelectedPlan}
                          hasRothRollOverSource={hasRothRollOverSource}
                          setRothHasRollOverSource={setRothHasRollOverSource}
                          values={values}
                          fields={fields}
                          setFieldValue={setFieldValue}
                          handleChange={handleChange}
                          setValues={setValues}
                          setFieldError={setFieldError}
                          sourceValidations={sourceValidations}
                          sourceLevelContributionTableError={
                            sourceLevelContributionTableError
                          }
                        />
                      )}
                    </div>
                  </LoaderWrapper>
                </div>
                {/* <WarningModal
                  show={modalVisible}
                  onHide={() => setModalVisible(false)}
                >
                  <div className="remove-text">
                    <h4>Are you sure?</h4>
                    <p>Your changes may be lost. Do you want to continue ?</p>
                    <Button
                      className="cancel-btn mr-4"
                      onClick={() =>
                        fromPage == 1
                          ? history.push(
                              getAdvancedPathWithParam({
                                path:
                                  MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERINAPPROVAL,
                                pathParam: [censusId, requestId],
                              })
                            )
                          : history.push(
                              getAdvancedPathWithParam({
                                path:
                                  MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                                pathParam: [FLOW_TYPES.EDIT, censusId],
                              })
                            )
                      }
                    >
                      Yes
                    </Button>
                    <Button
                      type="submit"
                      className="remove-btn"
                      onClick={() => {
                        runValidations.current = false;
                        onFormSubmit(values, { setFieldError });
                      }}
                    >
                      Save Draft
                    </Button>
                  </div>
                </WarningModal> */}
              </ManageCensusLayout>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default RollOverRequestContainer;
